export default __webpack_public_path__ + "static/main5-75bf03d40548cd0695ea3da5de45d325.png";